// 基本权限枚举
// 这个文件必须写注释！

export default {
    //单位权限
    "EDIT_COMPANY_GROUP"            :   "xnGroupEdit",    //单位分组修改
    "TAB_MANAGE"                    :   "xnTags",    //标签管理
    "ITEM_PROGRESS_MANAGE"          :   "systemConfigProgress",    //项目进度管理
    "CARRIER_PROGRESS_MANAGE"       :   "systemCarrierConfigProgress",    //载体进度管理
    "WATCH_CARD_RECORD"             :   "cardViewStatistical",    //查看名片统计
    "EDIT_COMPANY_INFO"             :   "xnEditCompany",    //编辑单位资料
    "EDIT_COMPANY_USER_INFO"        :   "editUser",   //编辑成员资料
    "AUTH_SETTING"                  :   "superSet",   //权限设置
    "CHANGE_USER_STATUS"            :   "banGlobalUser",   //禁止用户登录
    "SET_ADMINISTRATIVE_AREA"       :   "administrativeAreaConfig",     //行政区划管理
    "SET_BELONG_AREA"               :   "belongAreaConfig",     //所属区域管理
    "SET_ITEM_ORIGIN"               :   "itemOriginConfig",     //项目来源管理
    "SET_FILE_CATEGORY"             :   "fileCategoryConfig",     //附件管理
    "ADD_USER"                      :   "AddUser",     //添加成员
    "SET_PROFESSION_CATEGORY"       :   "professionCategoryConfig",     //专业类别管理
    "SET_COMPANY_AREA"              :   "areaConfig",       //企业区域管理
    //企业
    "EXPORT_ENTERPRISE"             :   "exportEnterprise",     //导出企业
    "RECYCLE_ENTERPRISE"            :   "recycleEnterprise",     //回收企业
    "APPROVE_ENTERPRISE"            :   "approveEnterprise",     //企业审核
    "ADD_INTEGRAL"                  :   "addEnterprise",     //企业积分录入
    "VIEW_REPORT"                   :   "viewEnterprise",     //查看报表
    "IMPORT_REPORT"                 :   "importEnterprise",     //上传佛高新报表
    "ENTERPRISE_ACCOUNT_CONFIG"     :   "enterpriseAccountConfig",     //企业账户管理
    "BAN_ENTERPRISE_ACCOUNT"        :   "banEnterpriseAccount",     //禁止企业账户登录
    //项目权限
    "EXPORT_ITEM"                   :   "exportItem",   //导出项目
    //载体权限
    "EXPORT_CARRIER"                :   "exportCarrier",   //导出载体
    //数据
    "DATA_MODULE_ENTRY"             :   "dataEntry",     //数据模块
    "EXPORT_DATA"                   :   "exportDataList",     //导出数据

    //前端的特殊权限 无法设置 也不显示
    'HASCOMPANY'                    :   "hasCompany",   //已经加入单位
    'HASNOTCOMPANY'                 :   "hasnotCompany",    //未加入单位
}


// WEBPACK FOOTER //
// ./src/staticData/baseAuthEnum.js